<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      opacity="0.900000036"
    >
      <g transform="translate(-368, -313)">
        <g id="Kort" transform="translate(239, 312)">
          <g id="Group" transform="translate(129, 1)">
            <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
            <path
              id="Path"
              d="M3,7 C3,5.8954305 3.8954305,5 5,5 L19,5 C20.1045695,5 21,5.8954305 21,7 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,7 Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <polyline
              id="Path"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="3 7 12 13 21 7"
            ></polyline>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
